import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withLocalize } from 'react-localize-redux'
import {
  getSnackbarMessage,
  getIsSnackbarVisible,
  getIsSnackbarSticky
} from 'common/selectors/snackbar'
import { hideSnackbar } from 'common/actions/snackbar'

import Snackbar from '@material-ui/core/Snackbar'
import IconButton from '@material-ui/core/IconButton'
import { Close } from '@material-ui/icons'
import styles from './SnackbarRoot.module.scss'

/**
 * Only the message that waits for the user can be closed by hand. Every other
 * message goes on its own after a few seconds, so a button on it would be in
 * the way without ever being needed.
 */
const SnackbarRoot = ({ message, translate, isVisible, isSticky, hideSnackbar }) => (
  <Snackbar
    message={message ? translate(message) : null}
    open={isVisible}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    className={styles.component}
    onClose={
      isSticky
        ? (event, reason) => {
            // A click anywhere on the page would take the message away before
            // the user has read it, so only the button closes it.
            if (reason !== 'clickaway') hideSnackbar()
          }
        : undefined
    }
    action={
      isSticky ? (
        <IconButton
          className={styles.close}
          size='small'
          color='inherit'
          disableRipple
          aria-label={translate('snackbar.close')}
          onClick={() => hideSnackbar()}
        >
          <Close fontSize='small' />
        </IconButton>
      ) : undefined
    }
  />
)

SnackbarRoot.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  isSticky: PropTypes.bool.isRequired,
  message: PropTypes.string,
  hideSnackbar: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  isVisible: getIsSnackbarVisible(state),
  isSticky: getIsSnackbarSticky(state),
  message: getSnackbarMessage(state)
})

const mapActionsToProps = {
  hideSnackbar
}

export default withLocalize(connect(mapStateToProps, mapActionsToProps)(SnackbarRoot))
